module.exports = __webpack_public_path__ + "57dbdde806c64502d53387e04462261f.svg";